let livemode=true;
let baseUrl='';
let logoUrl ='';
let Flagurl ='';
let KYCurl ='';

if (livemode) {
    baseUrl='https://parcelpost.in/api/';
    logoUrl ='https://cdn.parcelpost.in/Logo/';
    Flagurl = 'https://cdn.parcelpost.in/Flag/';
    KYCurl = 'https://cdn.parcelpost.in/KYC/';
    
} else {
    baseUrl='http://192.168.29.181:8000/api/';
    logoUrl ='https://cdn.parcelpost.in/Logo/';
    Flagurl = 'https://cdn.parcelpost.in/Flag/';
    KYCurl = 'https://cdn.parcelpost.in/KYC/';
}
let Global={
    baseUrl:baseUrl,
    logoUrl:logoUrl,
    flagurl:Flagurl,
    kyc:KYCurl,
    timezone:'Asia/Kolkata'
};
export default Global;